
import XHeader from 'vux/src/components/x-header/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Range from 'vux/src/components/range/index.vue'

import zcassistitem from '@/components/assist/zcassistitem'



export default {
name: 'record_capital_detail',
components: {XHeader, Badge, Range,zcassistitem},
data () {
return {
postadata: {},
paytypes: [],
copyBtn: null,
capitaldetail:{},

}
},
created () {



},
mounted () {
this.getZcDetail()
},
methods: {
getZcDetail(){
this.$https({
method: 'post',
url: this.BASE_URL+'cfs/zc/project/getHelpDetails',
data: {
acr026:this.G("zcuserid"),
afq005:this.$route.params.id,
acr001:this.$route.params.projectid,
token:localStorage.token,

},
}).then(res => {
this.capitaldetail=res.data.data

}).catch(err => {
this.showToast('','text',err.msg,'20em','','middle');
})
},
payhelp(item){
if(this.isWeixinCient()){
console.log('这是微信的我要支持')
this.$router.replace('/zchelphe/'+item.acr001+'/'+item.planMoney+'/'+item.title+'/'+this.G("zcuserid")+'/null/'+encodeURIComponent(this.G("zcnickname"))+'/null/null/null/'+encodeURIComponent(this.capitaldetail.acr036));
}else{
this.showToast('','text','请在微信内打开','20em','','')
}
},
gocartification (item) {
this.$router.push('/zccertificate/'+item.title+'/'+item.afq065+'/'+item.acr001+'/'+this.G("zcuserid")+'/null/'+encodeURIComponent(this.G("zcnickname"))+'/'+this.capitaldetail.afq007+'/'+encodeURIComponent(this.capitaldetail.acr036))
},
goack () {
this.$router.go(-1)
}
},

}



// WEBPACK FOOTER //
// ./src/crowd_fund/zcrec_detail.vue